export default __webpack_public_path__ + "static/media/Queen.a93e7812.mp3";